export const formatCleanCareDependantsPath = (path: string) => path.replace('/:tab?', '');
